import { Component, Input, OnInit } from "@angular/core";
import { Dictionary } from "../store/models/common_types";
@Component({
  selector: "app-checkbox-renderer",
  template: `
    <label
      nz-checkbox
      [(ngModel)]="dataObj.checked"
      [nzValue]="dataObj.value"
      [nzDisabled]="dataObj.disabled"
      (ngModelChange)="updateCheckbox()"
      >{{ dataObj.text }}</label
    >
  `,
  styles: [],
})
export class CheckboxRendererComponent implements OnInit {
  @Input() dataObj: Dictionary<any>;

  ngOnInit() {
    if (this.dataObj.disabled === undefined) {
      this.dataObj.disabled = false;
    }
  }
  updateCheckbox() {
    this.dataObj.callUpdateCallback(this.dataObj);
  }
}
